import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { GetDocumentEntityAccessRequest, GetDocumentEntityAccessResponse, GiveDocumentEntityAccessRequest, GiveDocumentEntityAccessResponse, RequestDocumentEntityAccessRequest, RequestDocumentEntityAccessResponse, SaveDocumentEntityAccessRequest, SaveDocumentEntityAccessResponse, ViewDocumentEntityAccessRequest, ViewDocumentEntityAccessResponse } from "../models/document-entity-management.models";

@autoinject
export class DocumentEntityAccessApi {

    public documenAccessApi: string = `${this.configService.config.urls.documentManagementApiUrl}/api/v1/DocumentEntityAccess`;

    constructor(private configService: ConfigService, private requestClientService: RequestClientService) { }
    
      public getDocumentEntityAccess(request: GetDocumentEntityAccessRequest): Promise<GetDocumentEntityAccessResponse> {
        return this.requestClientService.post(`${this.documenAccessApi}/getDocumentEntityAccess`, {}, request);
    }

    public saveDocumentEntityAccess(request: SaveDocumentEntityAccessRequest): Promise<SaveDocumentEntityAccessResponse> {
        return this.requestClientService.post(`${this.documenAccessApi}/saveDocumentEntityAccess`, {}, request);
    }

    public requestDocumentEntityAccess(request : RequestDocumentEntityAccessRequest): Promise<RequestDocumentEntityAccessResponse> {
        return this.requestClientService.post(`${this.documenAccessApi}/requestDocumentEntityAccess`, {}, request);
    }
    
    public giveDocumentEntityAccess(request: GiveDocumentEntityAccessRequest): Promise<GiveDocumentEntityAccessResponse> {
        return this.requestClientService.post(`${this.documenAccessApi}/giveDocumentEntityAccess`,{}, request);
    }

    public hasDocumentEntityAccess(request: ViewDocumentEntityAccessRequest): Promise<ViewDocumentEntityAccessResponse> {
        return this.requestClientService.post(`${this.documenAccessApi}/hasDocumentEntityAccess`, {}, request);
    }
}